import React from "react";
import { Link, useLocation } from "react-router-dom";

const ChatTrackerNav = () => {
  const location = useLocation();

  const isActive = (path) => {
    return location.pathname.includes(path);
  };

  return (
    <div className="sticky top-0 z-20 bg-[#0f1f3d]/85 backdrop-blur border-b border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16 items-center">
          <div className="flex">
            <div className="flex-shrink-0 flex items-center">
              <h1 className="text-lg sm:text-xl font-bold text-white tracking-tight">
                Ces Conversation Tracker
              </h1>
            </div>
            <div className="hidden sm:ml-6 sm:flex sm:space-x-8">
              <Link
                to="/admin-dashboard/chat-tracker"
                className={`${
                  location.pathname === "/admin-dashboard/chat-tracker"
                    ? "border-blue-400 text-white"
                    : "border-transparent text-gray-300 hover:text-white hover:border-white/20"
                } inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium transition-colors`}
              >
                Dashboard
              </Link>
              <Link
                to="/admin-dashboard/chat-tracker/analytics"
                className={`${
                  isActive("/analytics")
                    ? "border-blue-400 text-white"
                    : "border-transparent text-gray-300 hover:text-white hover:border-white/20"
                } inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium transition-colors`}
              >
                Analytics
              </Link>
              <Link
                to="/admin-dashboard/chat-tracker/settings"
                className={`${
                  isActive("/settings")
                    ? "border-blue-400 text-white"
                    : "border-transparent text-gray-300 hover:text-white hover:border-white/20"
                } inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium transition-colors`}
              >
                Settings
              </Link>
            </div>
          </div>
          <div className="hidden sm:ml-6 sm:flex sm:items-center gap-2">
            <Link
              to="/admin-dashboard"
              className="inline-flex items-center px-3 py-2 rounded-lg text-sm font-medium text-gray-200 hover:text-white hover:bg-white/10 transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 focus:ring-offset-[#0f1f3d]"
            >
              Back to Admin
            </Link>
            <button
              type="button"
              className="flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium text-white bg-gradient-to-r from-primary-blue to-blue-400 hover:brightness-105 hover:shadow-md transition-all focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 focus:ring-offset-[#0f1f3d]"
            >
              <span className="sr-only">Export data</span>
              <svg
                className="h-5 w-5"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                />
              </svg>
              <span className="hidden md:inline">Export</span>
            </button>
          </div>
          <div className="-mr-2 flex items-center sm:hidden">
            {/* Mobile menu button */}
            <button
              type="button"
              className="inline-flex items-center justify-center p-2 rounded-md text-gray-300 hover:text-white hover:bg-white/10 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-blue-500"
              aria-expanded="false"
            >
              <span className="sr-only">Open main menu</span>
              <svg
                className="block h-6 w-6"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu, show/hide based on menu state */}
      <div className="sm:hidden hidden">
        <div className="pt-2 pb-3 space-y-1">
          <Link
            to="/admin-dashboard/chat-tracker"
            className={`${
              location.pathname === "/admin-dashboard/chat-tracker"
                ? "bg-white/10 border-blue-400 text-white"
                : "border-transparent text-gray-300 hover:bg-white/5 hover:border-white/10 hover:text-white"
            } block pl-3 pr-4 py-2 border-l-4 text-base font-medium`}
          >
            Dashboard
          </Link>
          <Link
            to="/admin-dashboard/chat-tracker/analytics"
            className={`${
              isActive("/analytics")
                ? "bg-white/10 border-blue-400 text-white"
                : "border-transparent text-gray-300 hover:bg-white/5 hover:border-white/10 hover:text-white"
            } block pl-3 pr-4 py-2 border-l-4 text-base font-medium`}
          >
            Analytics
          </Link>
          <Link
            to="/admin-dashboard/chat-tracker/settings"
            className={`${
              isActive("/settings")
                ? "bg-white/10 border-blue-400 text-white"
                : "border-transparent text-gray-300 hover:bg-white/5 hover:border-white/10 hover:text-white"
            } block pl-3 pr-4 py-2 border-l-4 text-base font-medium`}
          >
            Settings
          </Link>
          <Link
            to="/admin-dashboard"
            className="block pl-3 pr-4 py-2 border-l-4 border-transparent text-gray-300 hover:bg-white/5 hover:border-white/10 hover:text-white text-base font-medium"
          >
            Back to Admin
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ChatTrackerNav;
